import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'Anteprima',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    submenu: [ ]
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    icon: 'mdi mdi-gauge',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '',
    title: 'Controlli',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    submenu: []
  },
  {
    path: '/admin/software-manager',
    title: 'Software Manager',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/admin/vps-manager',
    title: 'Vps Manager',
    icon: 'mdi mdi-server',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/admin/store',
    title: 'Store',
    icon: 'mdi mdi-view-carousel',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/admin/pagamenti',
    title: 'Pagamenti',
    icon: 'mdi mdi-cash-multiple',
    class: '',
    extralink: false,
    submenu: []
  }
];
